export interface Project {
  id: number;
  name: string;
  materials: Material[];
}

export interface Material {
  id: number;
  type: MaterialType;
  oriUrl: string;
  details: MaterialDetail[];
}

export enum MaterialType {
  VIDEO = 0,
  AUDIO = 1,
  MUSIC = 2,
  CAPTIONS = 3,
  TRANSLATION = 4,
}

export interface MaterialDetail {
  id: number;
  type: MaterialType;
  timeLineFrom: number;
  timeLineTo: number;
  from: number;
  to: number;
  vttUrl: string;
  vttString: string;
  hide: boolean;
  volume: number;
  speed: number;
  sentence: string;
  sentenceUrl: string;
  speakerId: number;
  subtitle: Subtitle;
  url: string;
  text: string;
  trackIndex: number;
  generating: boolean;
  mute: boolean;
  wordId?: number;
  subtitleSegmented: SubtitleSegmented[];
  isEdit?: boolean;
}

export interface Subtitle {
  id: number;
  type: MaterialType;
  text: string;
  timeLineFrom: number;
  timeLineTo: number;
}

export enum OperationType {
  INSERT = 0,
  MODIFY = 1,
  DELETE = 2,
  SPLIT = 3,
  HIDE = 4,
  VOLUME = 5,
  GENERATE = 6,
  BATCH_MODIFY = 7,
  MUTE = 9,
  SYNCTIME = 13,
}

export enum ProjectMode {
  TRANSLATION = 'translation',
  TRANSLATION_TTS = 'translation_and_tts',
  SUBTITLE = 'add_subtitle',
  SUBTITLE_TRANSLATION = 'add_subtitle_and_translation',
  REWRITE = 'rewrite',
  NARRATION = 'narration',
}

export interface SubtitleSegmented {
  id: number;
  timeLineFrom: number;
  timeLineTo: number;
  subtitleId?: number;
  text?: string;
}
